import { createContext, useContext } from "react";

import useAxios from "../Utils/useAxios";
import { downloadFile } from "../Utils/otherFunctions";
import { handleError, handleSuccess } from "../Utils/externalFunctions";
import { getItemCreateSuccessMsg, getItemDeleteSuccessMsg } from "../Constant/Message";

const DokumenContext = createContext();

export const useDokumen = () => useContext(DokumenContext);

const handleTemplateDownload = async (
  axiosInstance,
  endpoint,
  errorMessage
) => {
  try {
    const response = await axiosInstance.get(endpoint, {
      responseType: "blob",
    });
    downloadFile(response);
    return handleSuccess(response, "File berhasil diunduh!");
  } catch (error) {
    return handleError(error, errorMessage);
  }
};

export const DokumenProvider = ({ children }) => {
  const axiosInstance = useAxios();

  const api = {
    getDokumen: () =>
      axiosInstance
        .get("dokumen/")
        .catch((err) => handleError(err, "GET Dokumen")),

    createDokumen: (formData) =>
      axiosInstance
        .post("dokumen/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => handleSuccess(res, getItemCreateSuccessMsg("dokumen")))
        .catch((err) => handleError(err, "POST (Dokumen)")),

    getTemplateKalender: () =>
      handleTemplateDownload(
        axiosInstance,
        "/dokumen/template-kalender/",
        "GET Template Kalender"
      ),

    getTemplateSlip: () =>
      handleTemplateDownload(
        axiosInstance,
        "/dokumen/template-slip/",
        "GET Template Slip"
      ),

    getFile: (id) =>
      axiosInstance
        .get(`dokumen/${id}/`, {
          responseType: "blob",
        })
        .then((res) => {
          const filename = res.headers["content-disposition"]
            .split("filename=")[1]
            .replace(/['"]/g, "");
          const file = new Blob([res.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          const dom = document.createElement("a");
          dom.setAttribute("style", "display:none");
          dom.setAttribute("href", fileURL);
          dom.setAttribute("target", "_blank");
          dom.setAttribute("download", filename);
          document.body.appendChild(dom);
          dom.click();
          document.body.removeChild(dom);
          return handleSuccess(res, getItemCreateSuccessMsg("Dokumen"));
        })
        .catch((err) => handleError(err, "GET SK Dokumen File")),

    deleteDokumen: (id) =>
      axiosInstance
        .delete(`dokumen/${id}/`)
        .then((res) => handleSuccess(res, getItemDeleteSuccessMsg("Dokumen")))
        .catch((err) => handleError(err, "DELETE Dokumen")),
  };

  return (
    <DokumenContext.Provider value={api}>{children}</DokumenContext.Provider>
  );
};

export default DokumenContext;
